import transmissionValidator from "./transmissionValidator";

export default function*() {
    yield* [...transmissionValidator];
}
